import './_product.scss';

export default () => {};
